module.exports = __webpack_public_path__ + "img/Projector_icon.f559ca2f.png";